module.exports = __webpack_public_path__ + "img/swish.7df8cee9.png";